import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box} from '@material-ui/core'
import {Button, FormControl, TextField, Checkbox } from '@material-ui/core';

class EditPasswordPolicyDialog_ extends React.Component{

    constructor(props){
        super(props)

        const {passwordPolicy} = this.props

        this.state = {
            passwordPolicy: passwordPolicy,
            errors:{
                TotalCharacters: false,
                DigitCharacters: false,
                NonAlphaNumericCharacters: false
            },
            changed: false,
        }

        this.handleInput = this.handleInput.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleSave(){
        if(!this.checkErrors()){
            let passwordPolicy = {...this.props.passwordPolicy, ...this.state.passwordPolicy}
            this.props.onAction({type: 'PASSWORD_POLICY_EDITOR_SAVE', passwordPolicy: passwordPolicy})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'PASSWORD_POLICY_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'PASSWORD_POLICY_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        if(!this.state.changed) this.setState({changed: true})

        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value

        const passwordPolicy = {...this.state.passwordPolicy, [event.target.name]: val}

        const errors = this.validate(passwordPolicy)

        this.setState({passwordPolicy: passwordPolicy, errors: errors})

    }

    validate(passwordPolicy){

        let errors = this.state.errors;

        let validateTotalCharacters = /^\d+$/.test(passwordPolicy.TotalCharacters);
        if(passwordPolicy.TotalCharacters && !validateTotalCharacters){
            errors.TotalCharacters = this.props.t('IsNotInteger')
        }else{
            errors.TotalCharacters = false
        }

        let validateDigitCharacters = /^\d+$/.test(passwordPolicy.DigitCharacters);
        if(passwordPolicy.DigitCharacters && !validateDigitCharacters){
            errors.DigitCharacters = this.props.t('IsNotInteger')
        }else{
            errors.DigitCharacters = false
        }

        let validateNonAlphaNumericCharacters = /^\d+$/.test(passwordPolicy.NonAlphaNumericCharacters);
        if(passwordPolicy.NonAlphaNumericCharacters && !validateNonAlphaNumericCharacters){
            errors.NonAlphaNumericCharacters = this.props.t('IsNotInteger')
        }else{
            errors.NonAlphaNumericCharacters = false
        }
        
        return errors
    }

    checkErrors(){
        let error = this.state.errors.TotalCharacters || 
                    this.state.errors.DigitCharacters || 
                    this.state.errors.NonAlphaNumericCharacters

        return error
    }


    render(){
        const {t} = this.props

        const title = t('PasswordPolicy')

        console.log('render PasswordPolicy')
        console.log(this.state.passwordPolicy)

        const margin = {margin:'16px 0 8px 0'}

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:400}}>


            <Box textAlign="center" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={Boolean(this.state.passwordPolicy.Enabled)}
                            onChange={this.handleInput}
                            name="Enabled"
                            />
                            {t('EnforcePasswordPolicy')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="center" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary"
                            disabled={!this.state.passwordPolicy.Enabled}
                            checked={Boolean(this.state.passwordPolicy.UpperCharacters)}
                            onChange={this.handleInput}
                            name="UpperCharacters"
                            />
                            {t('UpperCaseCharacters')}
                    </label>
                </FormControl>
            </Box>


            <Box textAlign="center" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            disabled={!this.state.passwordPolicy.Enabled}
                            checked={Boolean(this.state.passwordPolicy.LowerCharacters)}
                            onChange={this.handleInput}
                            name="LowerCharacters"
                            />
                            {t('LowerCharacters')}
                    </label>
                </FormControl>
            </Box>
            
            <Box textAlign="">
                <TextField name="TotalCharacters"  
                    disabled={!this.state.passwordPolicy.Enabled}
                    margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.TotalCharacters?this.state.errors.TotalCharacters:t('PasswordLength')}
                    autoComplete="off"
                    error={this.state.errors.TotalCharacters!==false}
                    value={this.state.passwordPolicy.TotalCharacters}
                    onChange={this.handleInput}
                />
            </Box>
            

            <Box textAlign="">
                <TextField name="DigitCharacters"  
                    disabled={!this.state.passwordPolicy.Enabled}
                    margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.DigitCharacters?this.state.errors.DigitCharacters:t('MinDigitCharacters')}
                    autoComplete="off"
                    error={this.state.errors.DigitCharacters!==false}
                    value={this.state.passwordPolicy.DigitCharacters}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="">
                <TextField name="NonAlphaNumericCharacters"  
                    disabled={!this.state.passwordPolicy.Enabled}
                    margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.NonAlphaNumericCharacters?this.state.errors.NonAlphaNumericCharacters:t('MinNonAlphaNumericCharacters')}
                    autoComplete="off"
                    error={this.state.errors.NonAlphaNumericCharacters!==false}
                    value={this.state.passwordPolicy.NonAlphaNumericCharacters}
                    onChange={this.handleInput}
                />
            </Box>
    
        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditPasswordPolicyDialog = withTranslation()(EditPasswordPolicyDialog_);